(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["halo-sidebar-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    if (event.target.closest('[data-menu-close-sidebar]') || event.target.closest('.background-overlay')) {
      document.body.classList.remove('menu_open');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      document.body.classList.remove('menu_open');
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["senlasi-navigation-override"] && !Shopify.designMode) return;
  try {
    function activateSenlasiMegaTab(tab) {
    var menu = tab.closest('[data-senlasi-product-mega]');
    if (!menu) return;

    var index = tab.getAttribute('data-senlasi-mega-tab');
    menu.querySelectorAll('[data-senlasi-mega-tab]').forEach(function (item) {
      item.classList.toggle('is-active', item === tab);
    });
    menu.querySelectorAll('[data-senlasi-mega-panel]').forEach(function (panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-senlasi-mega-panel') === index);
    });
  }

  document.addEventListener('mouseover', function (event) {
    var tab = event.target.closest('[data-senlasi-mega-tab]');
    if (tab) activateSenlasiMegaTab(tab);
  });

  document.addEventListener('focusin', function (event) {
    var tab = event.target.closest('[data-senlasi-mega-tab]');
    if (tab) activateSenlasiMegaTab(tab);
  });

  function normalizeSenlasiMenuTitle(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function mountSenlasiMegaMenu(title, templateId, menuClass) {
    var template = document.getElementById(templateId);
    if (!template) return;

    document.querySelectorAll('.header-navigation .menu-lv-1 > a .text, .header-navigation .menu-lv-1 > details summary .text').forEach(function (label) {
      if (normalizeSenlasiMenuTitle(label.textContent) !== normalizeSenlasiMenuTitle(title)) return;

      var menuItem = label.closest('.menu-lv-1');
      if (!menuItem) return;

      menuItem.classList.add('dropdown', menuClass);
      menuItem.querySelectorAll(':scope > .header__submenu').forEach(function (submenu) {
        submenu.remove();
      });
      menuItem.appendChild(template.content.cloneNode(true));
    });
  }

  function mountSenlasiMegaMenus() {
    if (!window.matchMedia('(min-width: 1025px)').matches) return;

    mountSenlasiMegaMenu('Laptop Bags', 'senlasi-laptop-bags-template', 'senlasi-product-mega-menu');
    mountSenlasiMegaMenu('Travel Bags', 'senlasi-travel-bags-template', 'senlasi-product-mega-menu');
    mountSenlasiMegaMenu('Shop By Device', 'senlasi-device-menu-template', 'senlasi-device-mega-menu');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountSenlasiMegaMenus);
  } else {
    mountSenlasiMegaMenus();
  }

  document.addEventListener('shopify:section:load', mountSenlasiMegaMenus);
  setTimeout(mountSenlasiMegaMenus, 500);
  } catch(e) { console.error(e); }
})();

})();
